function SponsorCardHeader({ display_name, website, logo_url, name }) {
   return (
      <div>
         <h4 className="col-sm-12" style={{ fontSize: "18px", textTransform: "capitalize", marginTop: '2.5vh' }}>
            {display_name}
         </h4>
         <a rel='noreferrer' href={website} target="_blank">
            <img
               src={logo_url}
               className="img-fluid imgLogo"
               alt="logo"
            />
         </a>
         <p style={{ fontSize: "15px", color: "grey" }}>{name}</p>
      </div>
   )
}

export default SponsorCardHeader